import request from '@/services/request'
import { getApiUrl } from '@/utils/tool'

export function parentTransferInfo() {
  return request({
    baseURL: getApiUrl(),
    url: '/payment/parent-transfer-info',
    method: 'post',
    data: {}
  })
}

export function DepositType() {
  return request({
    baseURL: getApiUrl(),
    url: '/payment/deposit-type',
    method: 'post',
    data: {}
  })
}

export function DepositPayment(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/payment/deposit-payment',
    method: 'post',
    data: object
  })
}

export function DepositManual(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/payment/deposit-manual',
    method: 'post',
    data: object
  })
}

export function DepositQuery(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/payment/deposit-query',
    method: 'post',
    data: object
  })
}

export function depositRecord(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/payment/deposit-record',
    method: 'post',
    data: object
  })
}

export function withdrawalRecord(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/payment/withdrawal-record',
    method: 'post',
    data: object
  })
}

export function withdrawalWallet() {
  return request({
    baseURL: getApiUrl(),
    url: '/payment/withdrawal-wallet',
    method: 'post'
  })
}

export function goldInfo(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/payment/gold-info',
    method: 'post',
    data: object
  })
}

export function commissionToMain(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/payment/commission-to-main',
    method: 'post',
    data: object
  })
}

export function transfer(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/payment/transfer',
    method: 'post',
    data: object
  })
}

export function withdrawalCheck(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/payment/withdrawal-check',
    method: 'post',
    data: object
  })
}

export function withdrawalPayment(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/payment/withdrawal-payment',
    method: 'post',
    data: object
  })
}
export function withdrawalRequire() {
  return request({
    baseURL: getApiUrl(),
    url: '/payment/withdrawal-require',
    method: 'post'
  })
}

export function DepositBankcardInternal() {
  return request({
    baseURL: getApiUrl(),
    url: '/payment/deposit-bankcard-internal',
    method: 'post',
    data: {}
  })
}
export function DepositSetting() {
  return request({
    baseURL: getApiUrl(),
    url: '/payment/deposit-setting',
    method: 'post',
    data: {}
  })
}
export function DepositTransactions(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/payment/deposit-transactions',
    method: 'post',
    data: object,
    customConfig: {
      noLoading: true
    }
  })
}
export function checkDepositRate(payment_id) {
  return request({
    baseURL: getApiUrl(),
    url: '/payment/deposit-rate',
    method: 'post',
    data: { payment_id }
  })
}
